import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['template', 'container']

  declare readonly templateTarget: HTMLTemplateElement
  declare readonly containerTarget: HTMLElement

  connect (): void {
    const toggleButtons: NodeListOf<HTMLElement> = this.element.querySelectorAll('.category-toggle')

    toggleButtons.forEach((button: HTMLElement) => {
      const targetId: string | null = button.getAttribute('data-target')

      if (targetId?.trim() == null) return

      if (targetId.trim() !== '') {
        const targetElement: HTMLElement | null = document.getElementById(targetId)

        if (targetElement == null) {
          button.setAttribute('data-collapsed', 'true')
        } else {
          button.setAttribute('data-collapsed', 'false')
        }
      }
    })
  }

  toggle (event: Event): void {
    const button = event.currentTarget as HTMLElement
    const targetId = button.getAttribute('data-target')

    if (targetId?.trim() == null) return

    const targetElement = document.getElementById(targetId)

    if (targetElement == null) return

    const isCollapsed = button.getAttribute('data-collapsed') === 'true'
    const newState = !isCollapsed

    button.setAttribute('data-collapsed', newState.toString())

    const arrowIcon = button.querySelector('.arrow-icon') as HTMLElement

    arrowIcon.style.transform = newState ? 'rotate(180deg)' : 'rotate(0deg)'

    targetElement.style.display = newState ? 'none' : 'table-row-group'
  }

  add (event: Event): void {
    event.preventDefault()

    const content = this.templateTarget.content.cloneNode(true) as DocumentFragment

    const timestamp = new Date().getTime().toString()
    const nestedFields = content.querySelectorAll('[data-nested-field]')

    nestedFields.forEach(field => {
      const name = field.getAttribute('name')
      if (name != null) {
        field.setAttribute('name', name.replace(/NEW_RECORD/g, timestamp))

        const id = field.getAttribute('id')
        if (id != null) {
          field.setAttribute('id', id.replace(/NEW_RECORD/g, timestamp))
        }
      }
    })

    this.containerTarget.appendChild(content)
  }

  remove (event: Event): void {
    event.preventDefault()

    const target = event.target as HTMLElement
    const item = target.closest('[data-nested-item]') as HTMLElement

    if (item == null) return

    const destroyField = item.querySelector("input[name*='[_destroy]']") as HTMLInputElement

    if (destroyField != null) {
      destroyField.value = '1'
      item.style.display = 'none'
    } else {
      item.remove()
    }
  }

  highlightDuplicates (): void {
    const categoryNames: string[] = []
    const categoryFields = this.containerTarget.querySelectorAll('.category-name')

    categoryFields.forEach((field: Element) => {
      const inputField = field as HTMLInputElement
      const name = inputField.value.trim().toLowerCase()

      if (categoryNames.includes(name)) {
        inputField.classList.add('duplicate')
      } else {
        inputField.classList.remove('duplicate')
        categoryNames.push(name)
      }
    })
  }
}
